function popup() {

  // Obtem o popup
  var popup = document.getElementById("measurements-popup");

  // Obtem o link que abre o popup
  var link = document.getElementById("open-popup");

  // Obtem o elemento que fecha o popup
  var closeButton = document.getElementById("close-popup");

  // Quando o usuário clica no link, abre o popup 
  link.addEventListener('click', function(event) {
    // impede o comportamento padrão do link
    event.preventDefault();

    popup.style.display = "block";
  });

  // Quando o usuário clica no botão (x), fecha o popup
  closeButton.addEventListener('click', function(event) {
    // impede o comportamento padrão do link
    event.preventDefault();

    popup.style.display = "none";
  });

  // Quando o usuário clica fora do popup, ele fecha
  window.onclick = function(event) {
    if (event.target == popup) {
      popup.style.display = "none";
    }
  }
}
